export interface ViewProps extends React.HTMLAttributes<HTMLDivElement> {
  style?: React.CSSProperties;
  className?: string;
  children?: React.ReactNode;
}

const View: React.FC<ViewProps> = ({
  children,
  style,
  className = '',
  ...props
}) => {
  return (
    <div className={className} style={style} {...props}>
      {children}
    </div>
  );
};

export default View;
